import { render, staticRenderFns } from "./_ProxyStoreSkuEditor.vue?vue&type=template&id=dcedd0a4&"
import script from "./_ProxyStoreSkuEditor.vue?vue&type=script&lang=js&"
export * from "./_ProxyStoreSkuEditor.vue?vue&type=script&lang=js&"
import style0 from "./_ProxyStoreSkuEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports